<script>
// import Action from '@/components/Action'
import Icon from '@/components/Icon'
import { mapActions, mapGetters, mapState } from 'vuex'
import SelectField from '@/components/SelectField'
import FilterSearch from '@/components/FilterSearch.vue'
import ContentLoading from '@/components/ContentLoading'
import Table from '@/components/Table.vue'
import BrandLogo from '@/components/BrandLogo.vue'
import SkeletonLoader from '@/components/SkeletonLoader.vue'
import { createSearchGuard } from '@/utils/searchGuard'
export default {
  name: 'VehiclePlateSearch',

  components: {
    Icon,
    SelectField,
    FilterSearch,
    Table,
    ContentLoading,
    BrandLogo,
    SkeletonLoader,
  },

  data () {
    return {
      plateNew: '',
      selectedDescription: '',
      selectedRelevanceFilter: 'todos',
      selectedVehicleModel: null,
      results: null,
      loading: false,
      vehicleLoading: false,
      suggestionsLoading: false,
      isDropdownOpen: false,
      lastSearchedKey: null,
    }
  },

  computed: {
    ...mapGetters('vehicle', ['getVehicle', 'getVehicleBrand', 'getListSuggestions', 'getRegistrationPlate', 'getSelectedSuggestion', 'getItemsTable', 'getTableScrollPosition', 'getProductSearchLock']),
    ...mapState('vehicle', ['selectedSuggestion']),

    // Computed para filtrar produtos por relevância
    filteredProducts () {
      if (!this.getItemsTable || this.getItemsTable.length === 0) {
        return []
      }

      if (this.selectedRelevanceFilter === 'todos') {
        return this.getItemsTable
      }

      if (this.selectedRelevanceFilter === 'mais-relevantes') {
        // Filtra produtos com PERCENTUAL_SUCESSO maior que 0.5 e ordena por relevância
        return this.getItemsTable
          .filter(product => product.PERCENTUAL_SUCESSO && product.PERCENTUAL_SUCESSO >= 0.5)
          .sort((a, b) => (b.PERCENTUAL_SUCESSO || 0.5) - (a.PERCENTUAL_SUCESSO || 0.5))
      }

      return this.getItemsTable
    },

    hasMultipleOptions () {
      return this.getVehicle && this.getVehicle.length > 1
    },

    singleVehicleOption () {
      if (this.getVehicle && this.getVehicle.length === 1) {
        return this.getVehicle[0]
      }
      return null
    },

    vehicleOptions () {
      return this.getVehicle || []
    },

    selectedVehicleDisplayText () {
      if (this.selectedVehicleModel) {
        return `${this.getVehicleBrand || ''} ${this.selectedVehicleModel.busca}`
      }
      return 'Selecione a motorização'
    },

    placaFormatada: {
      get: function () {
        var regex = /^([A-Z]{3})(\d{4})$/ // Valida a entrada do usuário
        var placa = this.plateNew.toUpperCase().replace(/[^A-Z0-9]/g, '') // Remove caracteres inválidos
        var placaFormatada = placa.replace(regex, '$1-$2') // Formata a placa com hífen
        return placaFormatada
      },
      set: function (value) {
        var regex = /^([A-Z]{3})(\d{4})$/ // Valida a entrada do usuário
        var placa = value.toUpperCase().replace(/[^A-Z0-9]/g, '') // Remove caracteres inválidos
        this.plateNew = placa.replace(regex, '$1$2') // Atualiza a propriedade "placa" sem hífen
      },
    },
  },

  created () {
    if (this.getSelectedSuggestion && this.selectedDescription !== this.getSelectedSuggestion) {
      this.selectedDescription = this.getSelectedSuggestion
    }
    if (this.getRegistrationPlate && this.plateNew !== this.getRegistrationPlate) {
      this.plateNew = this.getRegistrationPlate
    }

    // O Tab usa v-if e remonta este componente a cada troca de aba, então a
    // trava é rehidratada do Vuex — senão ir em PRODUTOS e voltar zeraria o
    // cooldown e liberaria de novo o Enter repetido.
    this.searchGuard = createSearchGuard()
    const lock = this.getProductSearchLock
    if (lock && lock.key) {
      this.searchGuard.restore(lock.key, lock.at)
      // A chave de cache também vem do Vuex: com getItemsTable populado isso
      // evita refazer a request só por causa da troca de aba.
      this.lastSearchedKey = lock.key
    }
  },

  watch: {
    getVehicle: {
      handler (newValue) {
        if (newValue && newValue.length === 1) {
          // Auto-seleciona se há apenas uma opção
          this.selectedVehicleModel = newValue[0]

          if (this.selectedVehicleModel && this.selectedVehicleModel.busca) {
            this.loadSuggestions()
          }
        } else if (newValue && newValue.length > 1) {
          // Reseta seleção se há múltiplas opções
          this.selectedVehicleModel = null
        }
      },
      immediate: true,
    },
  },

  mounted () {
    // Adiciona listener para fechar dropdown ao clicar fora
    document.addEventListener('click', this.handleClickOutside)
  },

  beforeDestroy () {
    // Remove listener ao destruir o componente
    document.removeEventListener('click', this.handleClickOutside)
  },

  methods: {
    ...mapActions('products', ['getProduct']),
    ...mapActions(['setFeedback']),
    ...mapActions('vehicle', ['getVehiclePlate', 'addRegistrationPlate', 'selectSearchSuggestion', 'handleSearchSuggestions', 'searchProducts', 'setTableScrollPosition', 'setProductSearchLock']),

    searchInArray (payload) {
      let string = payload?.toUpperCase().trim()

      if (!string) {
        this.results = this.filteredProducts
        return this.results
      }

      this.results = []
      const searchWords = string.split(' ').filter(word => word.trim() !== '')
      // Usa filteredProducts em vez de getItemsTable para aplicar o filtro de relevância
      for (const obj of this.filteredProducts) {
        let found = true
        for (const searchWord of searchWords) {
          let matchFound = false
          for (const prop in obj) {
            if (typeof obj[prop] === 'string' && obj[prop].toUpperCase().indexOf(searchWord) !== -1) {
              matchFound = true
              break
            }
          }
          if (!matchFound) {
            found = false
            break
          }
        }
        if (found) {
          this.results.push(obj)
        }
      }
      return this.results
    },

    handlePlateSearch () {
      // logger.debug('plateNew: ', this.plateNew)
      if (this.plateNew.length !== 7) {
        return
      }

      // Consulta em voo: a placa só é gravada no fim, então sem esta guarda o
      // usuário reabriria a request a cada tecla.
      if (this.vehicleLoading) {
        return
      }

      if (this.getRegistrationPlate !== this.plateNew) {
        // A placa pode mudar enquanto o request está em voo (o usuário continua
        // digitando); guarda o valor consultado.
        const plate = this.plateNew

        this.setTableScrollPosition(0)
        this.vehicleLoading = true
        this.getVehiclePlate(plate)
          .then(() => {
            // Só marca a placa como consultada DEPOIS da resposta. Antes, a
            // gravação acontecia junto com o disparo: se o request falhasse, a
            // guarda acima passava a barrar a mesma placa e o usuário ficava
            // sem conseguir tentar de novo.
            this.addRegistrationPlate(plate)
            this.results = null
            this.selectedDescription = null
            this.selectedRelevanceFilter = 'todos'
            this.clearFilterSearch()
          })
          .catch(() => {
            // Falha na consulta: a placa não é gravada, permitindo re-tentativa.
          })
          .finally(() => {
            this.vehicleLoading = false
          })
      }

      if (this.$refs.plateSearch) {
        this.$refs.plateSearch.blur()
      }
    },

    clearFilterSearch () {
      if (this.$refs.filterSearchRef && this.$refs.filterSearchRef.$el) {
        const input = this.$refs.filterSearchRef.$el.querySelector('input')
        if (input) {
          input.value = ''
        }
      }
      this.selectedRelevanceFilter = 'todos'
    },

    async handleSearchFilter (value) {
      this.selectedDescription = value
      await this.handleProductSearch(value)
    },

    async handleProductSearch (selectedDescription) {
      if (!this.selectedVehicleModel) {
        return
      }

      let search = this.selectedVehicleModel.busca
      if (!search || search.trim().length === 0) {
        return
      }

      // Reaproveita cache: mesma busca + lista populada, não refaz request
      const searchKey = `${search}|${selectedDescription ?? ''}`
      if (searchKey === this.lastSearchedKey && this.getItemsTable && this.getItemsTable.length > 0) {
        this.results = this.filteredProducts
      } else if (!this.loading && this.searchGuard.start(searchKey)) {
        // Trava de execução — cobre o que o cache acima não cobre: request em
        // voo e a busca que já foi feita e não retornou nenhum produto.
        this.selectSearchSuggestion(selectedDescription)
        this.loading = true

        this.searchProducts({
          search: `${search} ${selectedDescription}`,
          type: 'descricao-veiculo',
          increaseRelevance: `${this.selectedVehicleModel.modelo || ''} ${this.selectedVehicleModel.relevancia || ''}`,
        }).then(() => {
          this.lastSearchedKey = searchKey
          this.results = this.filteredProducts
          // Arma o cooldown mesmo sem resultado, e persiste p/ sobreviver ao
          // remount da aba.
          this.searchGuard.settle(searchKey)
          this.setProductSearchLock(this.searchGuard.snapshot())
        }).catch(() => {
          // Falha não arma o cooldown: o usuário precisa poder tentar de novo.
          this.searchGuard.abort(searchKey)
        }).finally(() => {
          this.loading = false
        })
      }

      // Desfoca o select após processar a seleção, evitando disparos repetidos por foco preso.
      if (this.$refs.suggestionSelect) {
        this.$refs.suggestionSelect.blur()
      }
    },

    handleSelectProduct (product) {
      var search = product.CODIGO
      this.getProduct({
        search,
      }).then(() => {
        return this.$emit('openSideBarModal')
      })
    },

    handleRelevanceFilterChange () {
      if (this.results) {
        this.results = this.filteredProducts
      }
    },

    toggleDropdown () {
      this.isDropdownOpen = !this.isDropdownOpen
    },

    selectVehicle (vehicle) {
      this.selectedVehicleModel = vehicle
      this.isDropdownOpen = false
      if (vehicle && vehicle.busca) {
        this.loadSuggestions()
      }
    },

    loadSuggestions () {
      if (!this.selectedVehicleModel || !this.selectedVehicleModel.busca) {
        return
      }
      this.suggestionsLoading = true
      this.handleSearchSuggestions({ brand: this.getVehicleBrand, search: this.selectedVehicleModel })
        .finally(() => {
          this.suggestionsLoading = false
        })
    },

    closeDropdown () {
      this.isDropdownOpen = false
    },

    handleClickOutside (event) {
      // Fecha o dropdown se clicar fora do componente
      if (!this.$el.contains(event.target)) {
        this.closeDropdown()
      }
    },

    handleTableScroll (scrollTop) {
      this.setTableScrollPosition(scrollTop)
    },

  },
}
</script>

<template>
  <div :class="$classes['vehicle']">
    <div :class="$classes['content-wrapper']">
      <div :class="$classes['main-content']">
        <div id="content" :class="$classes['content']">
          <div :class="$classes['content-field']">
            <div :class="$classes['content-plate']">
              <label :class="$classes['label-info-plate']">Placa do veículo</label>
              <input ref="plateSearch" type="text" maxlength="7" :class="$classes['placa']" placeholder="XXX0000"
                v-model="placaFormatada" @input="handlePlateSearch()" autocomplete="off">
            </div>
            <div :class="$classes['content-input']">
              <label :class="$classes['label-info-plate']">Carro selecionado</label>
              <!-- Skeleton Loader -->
              <div v-if="vehicleLoading" :class="$classes['model-info-wrapper']">
                <div :class="$classes['skeleton-loader']">
                  <div :class="$classes['brand-logo']">
                    <skeleton-loader type="circle" :width="56" :height="56" />
                  </div>
                  <div :class="$classes['model-text-container']">
                    <skeleton-loader type="text" :width="'auto'" :height="18" rounded />
                    <skeleton-loader type="text" :width="130" :height="14" rounded />
                    <skeleton-loader type="text" :width="130" :height="14" rounded />
                  </div>
                </div>
              </div>
              <!-- Conteúdo do veículo -->
              <div v-else-if="getVehicle && getVehicle.length > 0" :class="$classes['model-info-wrapper']">
                <div :class="$classes['brand-logo']">
                  <brand-logo :brand-name="getVehicleBrand" size="large" />
                </div>
                <div :class="$classes['model-text-container']">
                  <div :class="$classes['model-main-text']">
                    <!-- Se há múltiplas opções, mostra dropdown customizado -->
                    <div v-if="hasMultipleOptions" :class="$classes['custom-vehicle-select']" @click="toggleDropdown">
                      <div :class="$classes['selected-display']">
                        <span :class="$classes['model']">{{ selectedVehicleDisplayText }}</span>
                      </div>
                      <icon name="caret-down" :class="$classes['dropdown-icon']" />

                      <div v-if="isDropdownOpen" :class="$classes['dropdown-menu']">
                        <div v-for="(vehicle, index) in vehicleOptions" :key="index" :class="[
                          $classes['custom-option'],
                          { [$classes['active']]: selectedVehicleModel && selectedVehicleModel.busca === vehicle.busca }
                        ]" @click.stop="selectVehicle(vehicle)">
                          <div :class="$classes['model-with-logo']">
                            <brand-logo :brand-name="getVehicleBrand" size="small" />
                            <span :class="$classes['model']">{{ getVehicleBrand + ' ' + vehicle.busca }}</span>
                          </div>
                          <span :class="$classes['info-motor']">Motor: {{ vehicle.motor || 'Versão não especificada'
                            }}</span>
                          <span :class="$classes['info-motor']">Valvulas: {{ vehicle.valvulas || 'Versão não especificada' }} {{ vehicle.modelo || '' }} </span>
                        </div>
                      </div>
                    </div>

                    <!-- Se há apenas uma opção, mostra texto estático -->
                    <span v-else-if="singleVehicleOption" :class="$classes['custom-vehicle-select-single']">
                      {{ (getVehicleBrand || '') + ' ' + singleVehicleOption.busca }}
                    </span>

                  </div>
                  <div :class="$classes['model-sub-text']" v-show="selectedVehicleModel">
                    motor: {{ (selectedVehicleModel && selectedVehicleModel.motor) || 'Versão não especificada' }}
                  </div>
                  <div :class="$classes['model-sub-text']" v-show="selectedVehicleModel">
                    válvulas: {{ (selectedVehicleModel && selectedVehicleModel.valvulas) || 'Versão não especificada' }}
                  </div>
                </div>
              </div>
              <!-- Placeholder quando não há veículo -->
              <div v-else :class="$classes['model-placeholder']">
                <icon name="car-side-solid-full" :class="$classes['placeholder-icon']" />
                <span :class="$classes['placeholder-text']">Nenhum modelo selecionado</span>
              </div>
            </div>
            <div :class="$classes['content-input']">
              <label :class="$classes['label-info-value']">Sugestão de busca</label>
              <!-- Skeleton Loader para sugestões -->
              <div v-if="suggestionsLoading" :class="$classes['select-skeleton-wrapper']">
                <skeleton-loader type="text" :width="'100%'" :height="40" rounded />
              </div>
              <!-- Select normal quando não está carregando -->
              <select-field ref="suggestionSelect" v-else v-model="selectedDescription" @input="handleProductSearch"
                :placeholder="selectedDescription ? selectedDescription : ' '" :disabled="!selectedVehicleModel"
                :class="{ [$classes['suggestion']]: true, [$classes['label-info-input']]: true, [$classes['outlined']]: true, [$classes['is-disabled']]: !selectedVehicleModel }">
                <template v-for="(suggestion, index) in getListSuggestions">
                  <option :key="index" :value="suggestion.DESCRICAO_CURTA"> {{
                    suggestion.DESCRICAO_CURTA }}</option>
                </template>
              </select-field>
              <label :class="[$classes['label-info-value'], $classes['label-red']]">Filtro de busca</label>
              <filter-search ref="filterSearchRef" @search="handleSearchFilter" :loading="loading"
                :disable="!selectedVehicleModel" :class="$classes['input-info-filterSearch']" outlined></filter-search>
            </div>
          </div>
        </div>
      </div>
      <div :class="$classes['content-table']">
        <select-field v-show="selectedVehicleModel && selectedDescription && !loading" v-model="selectedRelevanceFilter"
          :class="[$classes['relevance-filter'], $classes['label-info-input']]" @input="handleRelevanceFilterChange"
          :round="true" :rounded="'small'">
          <option value="todos">Todos</option>
          <option value="mais-relevantes">Mais relevantes</option>
        </select-field>

        <!-- Loading centralizado na área da tabela -->
        <div v-if="loading" :class="$classes['loading-container']">
          <content-loading :height="'200px'" />
        </div>

        <Table ref="tableComponent" v-else-if="selectedVehicleModel && selectedDescription && !loading"
          :filter="'simple'" :content="!results ? filteredProducts : results" @returnRow="handleSelectProduct($event)"
          :scroll-position="getTableScrollPosition" @table-scroll="handleTableScroll"
          :success-field="'PERCENTUAL_SUCESSO'" :titles="{
            CODIGO: { title: 'Código' },
            CODIGO_INDUSTRIA: { title: 'Cód. Indústria' },
            DESCRICAO_CURTA: { title: 'Descrição' },
            APLICACAO_COMPLETA: { title: 'Aplicação do veículo' },
            MSG_CONSULTA: { title: 'Avisos gerais' },
            DESCRICAO_DETALHE: { title: 'Detalhes do item' },
            PERCENTUAL_SUCESSO: {},
          }"></Table>
      </div>
    </div>
  </div>
</template>

<style module>
.vehicle {
  padding: 45px 30px 30px 0px;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.header-title {
  text-transform: uppercase;
  font-size: 24px;
  letter-spacing: 0.1em;
  color: #292929;
  visibility: hidden;
}

.main-content {
  display: flex;
  width: 100%;
  justify-content: space-between;
  background: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 12px 16px;
}

.content {
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  box-sizing: border-box;
}

.content-plate {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  width: auto;
  min-width: 250px;
  flex: 0 0 auto;
  padding-bottom: 25px;
  box-sizing: border-box;
}

.content-field {
  flex: 1;
  display: flex;
  /* flex-direction: column; */
  width: 100%;
  flex-wrap: wrap;
  gap: 15px;
  box-sizing: border-box;
  align-items: flex-start;
}

.content-input {
  width: 100%;
  min-width: 280px;
  flex: 1;
  /* padding-left: 20px; */
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.content-table {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  height: 25vh;
  margin: 65px 0 0 0;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

input[type="text"].placa {
  background: url('~@/assets/images/plate-vehicle-blank.png') no-repeat center center;
  background-size: cover;
  padding-top: 2vh;
  border: none;
  color: black;
  width: 100%;
  max-width: 250px;
  min-width: 180px;
  height: 100px;
  font-size: 36px;
  font-family: Arial, sans-serif;
  font-weight: 600;
  letter-spacing: 4px;
  background-color: transparent;
  text-align: center;
  text-transform: uppercase;
  box-sizing: border-box;
}

.label-info-value {
  padding: 10px 10px 10px 0px;
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;
  /*line-height: 18px;*/
  color: #292929;
  text-transform: uppercase;
  text-align: initial;
  line-height: 15px;
  letter-spacing: 0.1em;
}

.label-info-plate {
  padding: 10px 0 0 10px;
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;
  /*line-height: 18px;*/
  color: #292929;
  text-transform: uppercase;
  text-align: initial;
  line-height: 15px;
  letter-spacing: 0.1em;
}

.label-info-input {
  border: 0;
  color: #292929;
  padding: 5px;
  margin-bottom: 15px;
  font-size: 18px;
  font-weight: 600;
  line-height: 18px;
  text-transform: uppercase;
  text-align: initial;
  background: #fff;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Noto Sans", Ubuntu, Cantarell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}

.label-info-input.outlined {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}

.label-info-input.is-disabled {
  background: #f8f9fa;
  color: #6c757d;
  cursor: not-allowed;
  opacity: 0.8;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.08);
  border: 2px solid #dee2e6;
}

.label-info-input.model {
  max-width: 450px;
}

.label-info-input.suggestion {
  max-width: 700px;
}

.label-info-input.relevance-filter {
  max-width: 400px;
  min-width: 150px;
  align-self: flex-end;
  width: auto;
  border-radius: 5px;
  background: transparent;
  text-transform: none;
  font-size: 14px;
}

.input-info-filterSearch {
  margin-top: -20px;
  max-width: 700px;
}

.sidebar {
  width: 342px;
  position: sticky;
  top: 100px;
  z-index: 90;
}

@media (max-width: 1400px) {
  .vehicle {
    padding: 45px 10px 30px 0px;
  }

  .content-input {
    width: 100%;
    padding-left: 15px;
  }

  .content-field {
    gap: 12px;
  }
}

@media (max-width: 1024px) {
  .vehicle {
    padding: 45px 20px 30px 0px;
  }

  .content-field {
    gap: 10px;
  }

  .content-plate {
    min-width: 220px;
  }

  .content-input {
    min-width: 250px;
    padding-left: 12px;
  }

  .model-info-wrapper,
  .model-placeholder {
    min-width: 240px;
  }
}

@media (max-width: 1366px) and (min-width: 1025px) {
  .content-field {
    gap: 12px;
  }

  .content-plate {
    min-width: 240px;
  }

  .content-input {
    min-width: 270px;
    padding-left: 18px;
  }

  .model-info-wrapper,
  .model-placeholder {
    min-width: 260px;
  }

  .content {
    gap: 18px;
  }
}

@media (max-width: 912px) {

  .sidebar {
    width: auto;
    left: 10px;
    right: 10px;
  }

  .content-field {
    display: flex;
    flex-direction: column;
    padding-bottom: 30px;
    gap: 15px;
  }

  .content-plate {
    width: 100%;
    min-width: auto;
  }

  .content-input {
    width: 100%;
    padding-left: 0px;
    min-width: auto;
  }

  .model-info-wrapper,
  .model-placeholder {
    min-width: auto;
    width: 100%;
  }

  .custom-vehicle-select {
    width: 100%;
  }

  .dropdown-menu {
    width: 100%;
    max-width: 100%;
  }

}

@media (max-width: 767px) {
  .vehicle {
    padding: 25px 5px;
  }

  .content-table {
    display: flex;
    flex-direction: column;
  }

  .content {
    padding: 15px;
    gap: 15px;
  }

  .content-field {
    gap: 10px;
  }

  .model-info-wrapper,
  .model-placeholder {
    margin: 20px 0;
    padding: 10px 12px;
  }

  input[type="text"].placa {
    font-size: 28px;
    height: 80px;
    padding-top: 1.5vh;
  }

  .label-info-value,
  .label-info-plate {
    font-size: 11px;
    padding: 8px 8px 8px 0px;
  }

  .label-info-input {
    font-size: 16px;
    margin-bottom: 12px;
  }

  .custom-vehicle-select {
    width: 100%;
  }

  .dropdown-menu {
    width: 100%;
    max-width: 100%;
  }
}

@media (max-width: 480px) {
  .vehicle {
    padding: 20px 3px;
  }

  .content {
    padding: 10px;
    gap: 10px;
  }

  .content-field {
    gap: 8px;
  }

  .model-info-wrapper,
  .model-placeholder {
    margin: 15px 0;
    padding: 8px 10px;
    min-height: 50px;
  }

  .label-info-value,
  .label-info-plate {
    font-size: 10px;
    padding: 6px 6px 6px 0px;
  }

  .label-info-input {
    font-size: 14px;
    margin-bottom: 10px;
  }

  .custom-vehicle-select {
    padding: 6px 10px;
    width: 100%;
  }

  .dropdown-menu {
    max-width: calc(100vw - 40px);
    left: 0;
    right: 0;
    width: 100%;
  }
}

.model-info-wrapper {
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 12px 16px;
  min-height: 60px;
  width: 100%;
  margin-top: 10px;
  min-width: 260px;
  box-sizing: border-box;
}

.brand-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 70px;
  border-radius: 50%;
  flex-shrink: 0;
}

.brand-icon {
  width: 20px;
  height: 20px;
  color: white;
}

.model-text-container {
  flex: 1;
  display: flex;
  gap: 5px;
  flex-direction: column;
  justify-content: center;
}

.model-main-text {
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
  line-height: 1.2;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.custom-vehicle-select-single {
  padding: 8px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 40px;
}

.custom-vehicle-select {
  position: relative;
  cursor: pointer;
  border: 1px solid rgb(231, 231, 231, .35);
  border-radius: 8px;
  padding: 8px 12px;
  background: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 40px;
  transition: all 0.2s ease;
  width: 100%;
  box-sizing: border-box;
}

.custom-vehicle-select:hover {
  border-color: #1481ee;
  box-shadow: 0 2px 4px rgba(20, 129, 238, 0.1);
}

.selected-display {
  display: flex;
  gap: 8px;
  align-items: center;
  flex: 1;
}

.brand {
  font-weight: 600;
  color: #1481ee;
  font-size: 16px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.model {
  font-weight: 500;
  color: #2c3e50;
  font-size: 16px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.dropdown-icon {
  color: #6c757d;
  transition: transform 0.2s ease;
  font-size: 14px;
}

.custom-vehicle-select:hover .dropdown-icon {
  transform: rotate(180deg);
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
  margin-top: 4px;
  min-width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.custom-option {
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.custom-option:hover {
  background-color: #f8f9fa;
}

.custom-option:last-child {
  border-bottom: none;
}

.custom-option.active {
  background-color: #1481ee;
  color: white;
}

.custom-option.active .model {
  color: white;
  font-weight: 600;
}

.custom-option.active .info-motor {
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
}

.custom-option .brand {
  font-weight: 600;
  color: #1481ee;
  font-size: 14px;
}

.custom-option .model {
  font-weight: 500;
  color: #2c3e50;
  font-size: 14px;
}

.model-with-logo {
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-motor {
  color: #6c757d;
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;
  /* margin-left: auto; */
}

.model-sub-text {
  font-size: 13px;
  color: #7f8c8d;
  line-height: 1.2;
  font-weight: 500;
  text-transform: capitalize;
  padding-left: 12px;
}

.model-placeholder {
  display: flex;
  align-items: center;
  background: #f8f9fa;
  max-width: 100%;
  border: 2px dashed #dee2e6;
  border-radius: 4px;
  padding: 16px;
  margin: 10px 0;
  min-height: 60px;
  height: 80px;
  width: 100%;
  min-width: 260px;
  color: #6c757d;
  box-sizing: border-box;
}

.placeholder-icon {
  width: 24px;
  height: 24px;
  margin-right: 12px;
  color: #adb5bd;
}

.placeholder-text {
  font-size: 14px;
  font-weight: 500;
  color: #6c757d;
}

.skeleton-loader {
  display: flex;
  align-items: flex-start;
  width: 100%;
  gap: 16px;
}

.skeleton-loader .model-text-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
  padding-top: 4px;
}

.select-skeleton-wrapper {
  margin-bottom: 15px;
  width: 100%;
  max-width: 700px;
}
</style>
